import React from "react";

export default function Body({ invoice }) {
  return (
    <div className="paymentInvoice_body">
      <div className="invoiceBody_block invoiceBody_prop">
        <span>Enterprise</span>
        <span>Team</span>
        <span>Member</span>
        <span>Cycle</span>
      </div>
      <div className="invoiceBody_block invoiceBody_value">
        <span>{invoice.attributes.member.enterprise.name}</span>
        <span>{invoice.attributes.member.enterprise_team.title}</span>
        <span>{invoice.attributes.member.full_name}</span>
        <span>{invoice.attributes.cycle.name}</span>
      </div>
    </div>
  );
}

